import axios from 'axios'
import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMetaStore } from '../store/MetaStore'
import RoundResultsView from '../views/RoundResultsView'

const RoundResultsController = () => {
  const navigate = useNavigate()
  const [allEvents, setAllEvents] = useState([])
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear())

  const orgId = useMetaStore((state) => state.orgId)
  const setPageTitle = useMetaStore((state) => state.setPageTitle)

  useEffect(() => {
    setPageTitle('Round Results')
    fetchEvents()
  }, [])

  const fetchEvents = async () => {
    try {
      if (orgId) {
        const response = await axios.get(`/gskapi/event/org/${orgId}`)
        const sortedEvents = response.data
          .sort((a, b) => new Date(b.eventDate) - new Date(a.eventDate))
        setAllEvents(sortedEvents)
      }
    } catch (error) {
      console.error('Error fetching events:', error)
    }
  }

  const availableYears = useMemo(() => {
    const years = new Set(allEvents.map(event => new Date(event.eventDate).getFullYear()))
    if (!years.has(new Date().getFullYear())) {
      years.add(new Date().getFullYear())
    }
    return Array.from(years).sort((a, b) => b - a)
  }, [allEvents])

  const filteredEvents = useMemo(() => {
    return allEvents.filter(event => new Date(event.eventDate).getFullYear() === selectedYear)
  }, [allEvents, selectedYear])

  const handleEventClick = (eventId) => {
    navigate(`/leaderboard?eventId=${eventId}`)
  }

  return (
    <RoundResultsView
      events={filteredEvents}
      onEventClick={handleEventClick}
      selectedYear={selectedYear}
      availableYears={availableYears}
      onYearChange={setSelectedYear}
    />
  )
}

export default RoundResultsController
